import { useApp } from '@/context/AppContext';
import Toast from '@/components/ui/Toast';
import Modal from '@/components/ui/Modal';
import SyncIndicator from '@/components/ui/SyncIndicator';
import UserMenu from '@/components/ui/UserMenu';
import { OfflineBanner } from '@/components/OfflineBanner';
import { supabase } from '@/data/supabase';
import MobileHome  from '@/screens/mobile/MobileHome';
import MobileJobs  from '@/screens/mobile/MobileJobs';
import MobileClock from '@/screens/mobile/MobileClock';

// Owner nav (4 items)
const OWNER_NAV = [
  { id: 'home',  icon: '🏠', label: 'Home'  },
  { id: 'jobs',  icon: '🏗️', label: 'Jobs'  },
  { id: 'clock', icon: '⏱️', label: 'Clock' },
];

// Employee-only nav (just clock)
const EMPLOYEE_NAV = [
  { id: 'clock', icon: '⏱️', label: 'Clock In' },
];

const SCREEN_MAP = {
  home:  MobileHome,
  jobs:  MobileJobs,
  clock: MobileClock,
};

function initialsFor(s) {
  return (s || '').split(/\s+/).filter(Boolean).map(p => p[0]).slice(0, 2).join('').toUpperCase() || '??';
}

export default function MobileLayout() {
  const {
    mobileScreen, setMobileScreen, setForceView,
    userRole, userEmail,
  } = useApp();

  const isEmployee = userRole === 'employee';
  const navItems   = isEmployee ? EMPLOYEE_NAV : OWNER_NAV;
  const navInitials = initialsFor(userEmail?.split('@')[0] || 'SO');

  const CurrentScreen = SCREEN_MAP[mobileScreen] || (isEmployee ? MobileClock : MobileHome);

  return (
    <div className="mobile-shell">
      {/* Offline / queued-punch banner driven by IndexedDB queue */}
      <OfflineBanner supabase={supabase} />

      {/* Topbar */}
      <div className="topbar" style={{ padding: '0 14px' }}>
        <div className="wordmark" style={{ fontSize: 15 }}>
          <div className="wmark">S</div>
          SteelOps
        </div>
        <div className="topright" style={{ gap: 6 }}>
          <SyncIndicator compact />
          {!isEmployee && (
            <button
              className="view-toggle"
              style={{ fontSize: 11, padding: '4px 9px' }}
              onClick={() => setForceView('desktop')}
            >
              Desktop
            </button>
          )}
          <UserMenu initials={navInitials} />
        </div>
      </div>

      {/* Main scrollable area */}
      <div className="mobile-main">
        <CurrentScreen />
      </div>

      {/* Bottom nav */}
      <div className="bottom-nav safe-bottom">
        {navItems.map(n => (
          <button
            key={n.id}
            className={`bnav${mobileScreen === n.id ? ' active' : ''}`}
            onClick={() => setMobileScreen(n.id)}
          >
            <div className="bnav-icon">{n.icon}</div>
            {n.label}
          </button>
        ))}
      </div>

      <Modal />
      <Toast />
    </div>
  );
}
